module.exports = __webpack_public_path__ + "static/media/Melody Tse_CV_2024.39f30e2f.pdf";